import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

export class FormatDate {
  static DEFAULT_START_TIME = "06:00";
  static DEFAULT_END_TIME = "18:00";

  static formatDateToDisplay = (date: string, format = "DD/MM/YYYY") => {
    return dayjs(date, "DD/MM/YYYY HH:mm").format(format);
  };

  static formatDateToDisplayEN = (date: string, format = "DD/MM/YYYY") => {
    return dayjs(date, "YYYY-MM-DD").format(format);
  };

  static dayjsFormat = (date: string) => {
    if (date.split(" ").length > 1) {
      return dayjs(date, "DD/MM/YYYY HH:mm");
    }
    return dayjs(date, "DD/MM/YYYY");
  };

  static formatDateToPost = (date: any, isDateTime?: boolean) => {
    if (!dayjs(date).isValid()) {
      return null;
    } else {
      if (isDateTime) {
        return dayjs(date).format("DD/MM/YYYY HH:mm");
        // return dayjs(date).format("YYYY/MM/DD HH:mm");
      } else {
        return dayjs(date).format("DD/MM/YYYY");
      }
    }
  };

  static formatDateToPostEn = (date: any, isDateTime?: boolean) => {
    if (!dayjs(date).isValid()) {
      return null;
    } else {
      if (isDateTime) {
        return dayjs(date).format("YYYY-MM-DD HH:mm");
      } else {
        return dayjs(date).format("YYYY-MM-DD");
      }
    }
  };

  static dayjsTimeFormat = (date: string) => {
    if (date.includes(":") && date.split(" ").length === 1) {
      // It's time only (e.g. "06:00")
      return dayjs(date, "HH:mm");
    }

    if (date.split(" ").length > 1) {
      return dayjs(date, "DD/MM/YYYY HH:mm");
    }

    return dayjs(date, "DD/MM/YYYY");
  };

  static getDayjsTime = (date: string) => {
    return dayjs(date, "DD/MM/YYYY HH:mm").format("HH:mm").toString();
  };
}
